/**
 * Vue DatetimePicker
 * @ref https://www.npmjs.com/package/vuetify-datetime-picker
 */

import Vue from 'vue';
import DatetimePicker from 'vuetify-datetime-picker';
Vue.use(DatetimePicker);